import React from 'react'

import { IAmbulance, IPriceListItem } from '@/_types'

import AAmbulanceServicesTable from './a-ambulance-services-table'

interface IProps {
	ambulance: IAmbulance
	priceListItems: IPriceListItem[]
	/** Full ambulance price list — used for GA4 list `index` alignment with `view_item_list`. */
	allPriceListItems: IPriceListItem[]
}

export default function AAmbulanceServices({ ambulance, priceListItems, allPriceListItems }: IProps) {
	if (!priceListItems.length) {
		return null
	}

	return (
		<section id='cennik' className='pdt-30md pdt-70lg pdt-130 pdb-20md pdb-60lg pdb-0 price'>
			<div className='wrapper_full'>
				<div className='wrapper_amb wrapper_amb--big'>
					<div className='section_head mgl-0lg mgl-120'>
						<div className='anim_delay anim_drop1 observe'>
							<h2 className='title_h1 mgr-0lg mgr-40'>
								Balíky nadštandardných služieb
							</h2>
						</div>
						<div className='dflex mgt-10lg mgt-20 justify-between align-start flex-dir-column-mdm'>
							<div className='page_content reset_margins text_s16 text_s14_lgm nobalance'>
								<p>
									Nadštandardné služby Polikliniky Medante, ktoré nie sú hradené z
									verejného zdravotného poistenia.
								</p>
							</div>
						</div>
					</div>

					<AAmbulanceServicesTable
						ambulance={ambulance}
						priceListItems={priceListItems}
						allPriceListItems={allPriceListItems}
					/>
				</div>
			</div>
		</section>
	)
}
